export default __webpack_public_path__ + "static/media/icon-circle-applicant-header.9e97ac77.svg";